module.exports = __webpack_public_path__ + "img/image (5).eeb711af.webp";